<template>
  <p>
    <slot v-if="!fieldName" />
    <span v-else>
      <strong>{{ fieldName }}:</strong>
      {{ withStringFallback(value) }}
    </span>
  </p>
</template>
<script lang="ts">
export default {
  name: 'lp-expandable-section-element',
}
</script>
<script lang="ts" setup>
const withFallback = <T,>(value: T | null | undefined, defaultValue: T): T =>
  value === undefined || value === null ? defaultValue : value
const withStringFallback = (value: unknown, defaultValue = '-'): string =>
  withFallback(value as null | undefined, defaultValue)

defineProps<{
  fieldName?: string
  value?: number | string | null
}>()
</script>
